import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJActionImageManipulation from '../../../redux/action/FJActionImageManipulation';
import FJBrushCardContainer from '../../../common/components/FJBrushCard/FJBrushCardContainer';
import PropTypes from 'prop-types';

const FJScratchOrFoldCardContainer = props => {
    const { disabled } = props;
    const switchScratchOrFold = useSelector(state => state.imageManipulation.switchScratchOrFold);

    const dispatch = useDispatch();

    const changeSwitchScratchOrFold = useCallback(
        value => {
            dispatch(FJActionImageManipulation.setSliceSwitchScratchOrFoldAction(value));
        },
        [dispatch],
    );

    return (
        <FJBrushCardContainer
            title='ai-scratch-fold-restoration'
            active={switchScratchOrFold}
            changeActive={changeSwitchScratchOrFold}
            disabled={disabled}
        />
    );
};

FJScratchOrFoldCardContainer.propTypes = {
    disabled: PropTypes.bool,
};

export default FJScratchOrFoldCardContainer;
